import * as api from 'Shared/api';

export const updateSelectedUuids = (
  uuid,
  params = { isOneSelected: false, isMetaPressed: false, isShiftPressed: false }
) => (dispatch, getState) => {
  const { workspace, selectedUuids, sortedActionItemsUuids, sortedDiscussionTopicsUuids } = getState();
  if (!uuid && !selectedUuids.length) return;
  dispatch({
    type: 'UPDATE_SELECTED_ITEMS',
    payload: {
      uuid,
      params,
    },
    sortedActionItemsUuids,
    sortedDiscussionTopicsUuids,
  });

  if (workspace?.id) {
    api.updatePresenceData({ workspaceItemUuid: uuid, workspaceId: workspace.id });
  }
};

export const clearSelectedUuids = () => dispatch => dispatch({ type: 'CLEAR_SELECTED_ITEMS' });
